import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FileTaskCountQueryVariables = Types.Exact<{
  filter: Types.GetByIdFilter;
}>;


export type FileTaskCountQuery = { file?: { taskCount?: number | null } | null };


export const FileTaskCountDocument = /*#__PURE__*/ gql`
    query fileTaskCount($filter: GetByIdFilter!) {
  file(filters: $filter) {
    taskCount
  }
}
    `;

export function useFileTaskCountQuery(options: Omit<Urql.UseQueryArgs<FileTaskCountQueryVariables>, 'query'>) {
  return Urql.useQuery<FileTaskCountQuery, FileTaskCountQueryVariables>({ query: FileTaskCountDocument, ...options });
};